import moment from 'moment';

function printDate(datetime?: string) {
  if (datetime === '0000-00-00 00:00:00' || !datetime) {
    return '';
  }
  // const date = moment(datetime);
  // return date.format('MM/DD/YYYY');
  return moment(datetime).format('MM/DD/YYYY');
}

function iso8601(datetime: string) {
  if (!datetime) {
    return '0000-00-00 00:00:00';
  }
  return moment(new Date(datetime)).format('YYYY-MM-DD HH:mm:ss');
}

export { printDate, iso8601 };
